import { render } from "./DashboardWireframe.vue?vue&type=template&id=4b1867b7&scoped=true"
import script from "./DashboardWireframe.vue?vue&type=script&lang=js"
export * from "./DashboardWireframe.vue?vue&type=script&lang=js"

import "./DashboardWireframe.vue?vue&type=style&index=0&id=4b1867b7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b1867b7"]])

export default __exports__